import React, { useState } from 'react';
import axios from 'axios';
import '../MandantForm.css';
import { MandantData } from '../MandantenList';
import RollenAuswahl from '../RollenAuswahl';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

export const ROLLEN = [
  'SuperAdmin', 'Admin', 'Lagerleiter', 'Einkäufer', 'Produktionsleiter',
  'Geschäftsführer', 'Buchhaltung', 'Verkäufer', 'Projektleiter',
  'Projektmitarbeiter', 'Personalverwaltung', 'Arbeiter',
];

interface EinladenDialogProps {
  authToken: string;
  mandanten: MandantData[];
  onClose: () => void;
  onDone: () => void;
}

/** Baut aus einem Einladungs-Token den fertigen Registrier-Link. */
export const registrierLink = (token: string) =>
  `${window.location.origin}/registrieren?token=${token}`;

const EinladenDialog: React.FC<EinladenDialogProps> = ({ authToken, mandanten, onClose, onDone }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [rollen, setRollen] = useState<string[]>(['Verkäufer']);
  const [tenantId, setTenantId] = useState<string>('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(false);
  const [link, setLink] = useState<string | null>(null);
  const [kopiert, setKopiert] = useState(false);
  const [versendet, setVersendet] = useState(false);
  const [linkSichtbar, setLinkSichtbar] = useState(false);

  const absenden = async (ev: React.FormEvent) => {
    ev.preventDefault();
    if (rollen.length === 0) {
      setFehler('Mindestens eine Rolle ist erforderlich.');
      return;
    }
    setLaedt(true);
    setFehler(null);
    try {
      const body: any = { name, email, rollen, rolle: rollen[0] };
      if (tenantId) body.tenant_id = Number(tenantId);
      const r = await axios.post(`${API_URL}/api/benutzer/einladen`, body, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      setLink(registrierLink(r.data.einladungs_token));
      setVersendet(!!r.data.email_versendet);
      onDone();
    } catch (e: any) {
      setFehler(e.response?.data?.detail || 'Einladung fehlgeschlagen.');
    } finally {
      setLaedt(false);
    }
  };

  const kopieren = () => {
    if (!link) return;
    navigator.clipboard.writeText(link).then(() => {
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2000);
    });
  };

  return (
    <div className="mandant-form-overlay" onClick={onClose}>
      <div className="mandant-form-modal" onClick={e => e.stopPropagation()}>
        <div className="mandant-form-header">
          <span className="mandant-form-title">Benutzer einladen</span>
          <button className="btn-close-modal" onClick={onClose}>✕</button>
        </div>

        {link ? (
          <div className="mandant-form">
            {versendet ? (
              <p>Einladung an <strong>{email}</strong> verschickt. Der Link ist 72 Stunden gültig.</p>
            ) : (
              <p>Mailversand ist nicht eingerichtet – bitte den Link manuell per E-Mail oder Messenger an die Person schicken:</p>
            )}
            {(!versendet || linkSichtbar) ? (
              <div className="form-group">
                <input type="text" readOnly value={link} onFocus={e => e.target.select()} />
              </div>
            ) : (
              <button className="btn-cancel" type="button" onClick={() => setLinkSichtbar(true)}>Link trotzdem anzeigen</button>
            )}
            <div className="form-actions">
              {(!versendet || linkSichtbar) && (
                <button className="btn-save" onClick={kopieren}>{kopiert ? 'Kopiert ✓' : 'Link kopieren'}</button>
              )}
              <button className="btn-cancel" onClick={onClose}>Schließen</button>
            </div>
          </div>
        ) : (
          <form className="mandant-form" onSubmit={absenden}>
            <div className="form-group">
              <label>Name</label>
              <input value={name} onChange={e => setName(e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label>E-Mail</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Rollen</label>
              <RollenAuswahl rollen={ROLLEN} value={rollen} onChange={setRollen} />
            </div>
            <div className="form-group">
              <label>Mandant</label>
              <select value={tenantId} onChange={e => setTenantId(e.target.value)}>
                <option value="">— Mandant wählen —</option>
                {mandanten.map(m => (
                  <option key={m.mandant_id} value={m.mandant_id}>{m.firmenname}</option>
                ))}
              </select>
              <span className="form-hint">Leer = mandantenlos (nur für SuperAdmin-Konten sinnvoll)</span>
            </div>
            {fehler && <div className="form-error">{fehler}</div>}
            <div className="form-actions">
              <button className="btn-save" type="submit" disabled={laedt}>
                {laedt ? 'Lade ein …' : 'Einladen'}
              </button>
              <button className="btn-cancel" type="button" onClick={onClose}>Abbrechen</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default EinladenDialog;
